// extracted by mini-css-extract-plugin
module.exports = {"container":"LayoutBackOffice_container__JXCjv","body":"LayoutBackOffice_body__1Ck34"};